// extracted by mini-css-extract-plugin
module.exports = {"formWidth":"NewUserForm_formWidth__2rGuw"};